import React, { ChangeEvent, useEffect } from 'react';
import { useEventContext } from '../../../context/EventProvider';
import { useRegistrationStore } from '../../../store/registrationStore';
import Title from '../Title';
import PaymentStep from './PaymentStep';
import { StepDataMap } from './index';

const TicketTypeStep = () => {
  const { ticket_types } = useEventContext();

  const parsedTicketTypes = ticket_types?.map(type => {
    const originalId = type?.documentId;
    return {
      ...type,
      originalId
    };
  });

  // Need to remove the registration_type ticket type due to a backwards compatibility issue
  // https://scoopnewsgroup.slack.com/archives/C01S30FJF3L/p1717439720903359
  const filteredTicketTypes = parsedTicketTypes?.filter(
    type => type.name !== 'registration_type'
  );

  const {
    userData,
    updateUserData,
    markStepValidated,
    removeStep,
    addStep,
    dynamicSteps
  } = useRegistrationStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const newData: StepDataMap['ticketTypeStep'] = {
      ticketTypeId: value
    };

    updateUserData('ticketTypeStep', newData);

    if (value) {
      markStepValidated(1);

      const selectedTicketType = filteredTicketTypes?.find(
        type => Number(type.originalId) === Number(value)
      );
      if (
        selectedTicketType &&
        (selectedTicketType.label?.toLowerCase() === 'government' ||
          selectedTicketType.label?.toLowerCase() === 'press')
      ) {
        if (dynamicSteps.some(step => step.key === 'paymentStep')) {
          removeStep('paymentStep');
        }
      } else {
        if (!dynamicSteps.some(step => step.key === 'paymentStep')) {
          addStep('paymentStep', PaymentStep);
        }
      }
    } else {
      markStepValidated(1, false);
    }
  };

  useEffect(() => {
    if (userData.ticketTypeStep?.ticketTypeId) {
      markStepValidated(1);
    }
  }, [userData, markStepValidated]);

  const radioStyles =
    'w-4 h-4 text-red-600 focus:ring-transparent ring-offset-gray-800 focus:ring-0 border-gray-600';

  const formatPrice = (price: number | string): string => {
    const priceNumber = Number(price);

    if (isNaN(priceNumber) || priceNumber === 0) {
      return 'FREE';
    }

    return `$${priceNumber.toFixed(2)}`;
  };

  return (
    <>
      <Title title="TICKETS" />
      {filteredTicketTypes?.map((ticketType, index, { length }) => (
        <>
          <hr />
          <div key={ticketType.originalId} className="flex my-5">
            <div className="flex items-center h-5">
              <input
                type="radio"
                name="ticket"
                value={ticketType.originalId.toString()}
                checked={
                  userData.ticketTypeStep?.ticketTypeId ===
                  ticketType.originalId.toString()
                }
                onChange={handleChange}
                id={`helper-radio-${ticketType.originalId}`}
                className={radioStyles}
              />
            </div>
            <div className="flex flw-row justify-between w-[100%] items-end">
              <div className="ms-2 text-sm">
                <label
                  htmlFor={`helper-radio-${ticketType.originalId}`}
                  className="font-medium text-gray-900"
                >
                  {ticketType.label}
                </label>
                <p
                  id={`helper-radio-text-${ticketType.originalId}`}
                  className="text-xs font-normal text-gray-500"
                >
                  {ticketType.description}
                </p>
              </div>
              <p className="text-black text-[17px] font-bold font-['Inter'] text-right translate-y-[-10px]">
                {formatPrice(ticketType.cost)}
              </p>
            </div>
          </div>
          {length - 1 === index && <hr />}
        </>
      ))}
    </>
  );
};

export default TicketTypeStep;
